var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M-6364,1006a.992.992,0,0,1-1-.982c0-4.973,4.487-9.019,10-9.019s10,4.046,10,9.019a.992.992,0,0,1-1,.982Zm1.078-1.965h15.845c-.543-3.426-3.89-6.072-7.923-6.072S-6362.379,1000.609-6362.922,1004.036ZM-6360,989a5.006,5.006,0,0,1,5-5,5.007,5.007,0,0,1,5,5,5.007,5.007,0,0,1-5,5A5.006,5.006,0,0,1-6360,989Zm1.818,0a3.2,3.2,0,0,0,3.182,3.2,3.2,3.2,0,0,0,3.184-3.2,3.2,3.2,0,0,0-3.184-3.2A3.2,3.2,0,0,0-6358.183,989Z",
    transform: "translate(6367 -983)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6512",
    "data-name": "Rectangle 6512",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.747953605f9e1054fa2ab9bc6ae00afd.svg";
export { ForwardRef as ReactComponent };